import React, { useEffect, useState } from 'react';
import { Dialog } from '@mui/material';
import { useHistory } from 'react-router-dom';

const DocumentSignModal = ({ match }) => {
  const history = useHistory();
  const { documentId } = match.params;
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
    history.push(`/`);
  };

  useEffect(() => {
    window.pandadoc_embed_config = {
      embed_uuid: documentId,
      width: 900,
      height: 700,
      element_id: 'eOTEwMTcx'
    };

    (() => {
      const pds = document.createElement('script');
      pds.type = 'text/javascript';
      pds.async = true;
      pds.src = 'https://dr79nymq4x8i9.cloudfront.net/embed/embed.js';
      (
        document.getElementsByTagName('head')[0] ||
        document.getElementsByTagName('body')[0]
      ).appendChild(pds);
    })();
  }, [documentId]);
  return (
    <Dialog
      maxWidth={false}
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
    >
      <div>
        <div id="eOTEwMTcx" />
      </div>
    </Dialog>
  );
};

export default DocumentSignModal;
